.container {
  max-height: calc(100vh - 100px);
  width: 300px;
}

.listContainer {
  height: 100%;
  overflow: hidden auto;
  max-height: 80vh;
}

.itemCell {
  min-height: 32px;
  cursor: pointer;
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 5px;
  padding-bottom: 5px;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
}

.itemCell:hover {
  background: #e6e6e6;
}

.itemButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 28px;
  height: 28px;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
  background-color: white;
  margin: auto 2.5px;
  cursor: pointer;
}

.itemButton:hover {
  background-color: #e6e6e6;
}

.chatGroup {
  margin: auto 5px;
  width: 100%;
}

.spinnerContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 22px;
  margin-top: -8px;
}

.chatList {
  width: 100%;
}

.chatMonth {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
  padding-left: 15px;
}

.chatTitle {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.chatHistoryListContainer {
  height: 100%;
}

.historyContainer {
  width: 20vw;
  background: radial-gradient(
    108.78% 108.78% at 50.02% 19.78%,
    #ffffff 57.29%,
    #eef6fe 100%
  );
  border-radius: 8px;
  max-height: calc(100vh - 105px);
  box-shadow:
    0px 2px 4px rgba(0, 0, 0, 0.14),
    0px 0px 2px rgba(0, 0, 0, 0.12);
  overflow-y: hidden;
}

.historyPanelTopRightButtons {
  height: 48px;
}

@media (max-width: 480px) {
  .container {
    width: 100%;
  }
}
